import { css } from '@emotion/react';

export const root = (width?: any, disabledBorder = 'var(--color-background-disabled)', height?: any) => css`
  display: flex;
  align-items: center;
  ${width ? `width: ${width};` : 'max-width: 49.6rem;'}
  height: ${height ? height : '4.8rem'};
  position: relative;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border: 0.1rem solid var(--color-foreground-neutral);
    border-radius: 0.4rem;
    transition: border-color 0.3s linear, background-color 0.3s linear;
    pointer-events: none;
  }

  /* focus */
  &:focus-within {
    &::before {
      border-width: 0.2rem;
      border-color: var(--color-primary-default) !important;
    }
  }

  /* disabled */
  &[aria-disabled='true'] {
    background-color: var(--color-background-light);
    &::before {
      border-color: ${disabledBorder};
    }
  }

  /* invalid */
  &[aria-invalid='true'] {
    &::before {
      border-width: 0.2rem;
      border-color: var(--color-secondary-default);
    }
  }
`;

export const input = ({
  disabledColor = 'var(--color-text-disabled)',
  disabledBgColor = '',
  padding = '0 1.6rem',
}) => css`
  width: 100%;
  height: 100%;
  flex: 1;
  padding: ${padding};
  border: 0;
  background: white;
  box-shadow: none;
  font-family: inherit;
  font-size: 1.6rem;
  line-height: 1;
  outline: none;
  color: inherit;
  &::placeholder {
    color: var(--color-text-disabled);
    opacity: 1; /* Firefox */
  }
  &:-ms-input-placeholder {
    color: var(--color-text-disabled); /* Internet Explorer 10-11 */
  }
  &::-ms-input-placeholder {
    color: var(--color-text-disabled); /* Microsoft Edge */
  }
  /* disabled */
  &[disabled] {
    color: ${disabledColor};
    ${disabledBgColor ? `background-color: ${disabledBgColor};` : ''}
    -webkit-text-fill-color: ${disabledColor};
    opacity: 1; /* required on iOS */
  }
`;
